<template >
  <div class="">
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-else>
        <v-slide-x-reverse-transition>
            <v-alert type="error" class="alert_all_page" v-if="alert_error === true">{{ alert_message_error }}</v-alert>
            <v-alert type="success" class="alert_all_page" v-if="alert_success === true">{{ alert_message_success
            }}</v-alert>
        </v-slide-x-reverse-transition>
        <v-row>
          <v-col cols="6 pa-10">
            <div class="font-26 bold pb-1">รายการสินค้า</div>
            <v-divider class="pb-4" style="border-color: #B0886B;"></v-divider>
            <v-row>
              <v-col cols="12 scroll-monitor">
               
                <v-row v-for="item in messages.product_data" :key="item.id">
                  <v-col cols="12 flex-center-between font-20 ">
                    <div>{{item.name}}</div>
                    <div>
                      <!-- <span class="color-gray line_through">180 </span> -->
                      <span>{{formatPrice(item.total_price)}} </span>
                    </div>
                  </v-col>
                  <v-col cols="12 pt-0">
                    <div class="font-20"><v-icon></v-icon> x{{formatPrice(item.qty)}}  <v-chip class="bg-org-bold" color="#fff">{{formatPrice(item.price_standard)}}</v-chip></div>
                  </v-col>
                  <v-col cols="12 pt-0 flex-center-between" v-if="item.discount > 0">
                    <div class="font-20 color-gray"><v-icon></v-icon> ส่วนลด {{item.name}}</div>
                    <div>
                      <span>- {{formatPrice(item.discount)}}</span>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <v-divider></v-divider>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col v-if="messages.promotion_discount > 0" cols="12 flex-center-between font-20 ">
                    <div>ส่วนลดโปรโมชั่น</div>
                    <div>
                      <!-- <span class="color-gray line_through">180 </span> -->
                      <span> <span class="color-red">-</span> {{formatPrice(messages.promotion_discount)}} </span>
                    </div>
                  </v-col>
         
                  <v-col cols="12">
                    <v-divider></v-divider>
                  </v-col>
                </v-row>

                

              </v-col>
            </v-row>
            

            

            <!-- <v-row>
              <v-col cols="12"></v-col>
            </v-row> -->

            <v-row>
              <v-col cols="12 flex-center-between font-20 pb-0">
                  <div>มูลค่าสินค้า</div>
                  <div>
                    <!-- <span class="color-gray line_through">180 </span> -->
                    <span>{{formatPrice(messages.cost ? messages.cost : 0)}} </span>
                  </div>
              </v-col>
              <v-col cols="12 flex-center-between font-20 pb-0">
                  <div>ส่วนลดท้ายบิล</div>
                  <div>
                    <!-- <span class="color-gray line_through">180 </span> -->
                    <span>- {{formatPrice(messages.discount_last)}} </span>
                  </div>
              </v-col>
              <v-col cols="12 flex-center-between font-20 pb-0">
                  <div>ภาษีมูลค่าเพิ่ม 7%</div>
                  <div>
                    <!-- <span class="color-gray line_through">180 </span> -->
                    <span>+ {{formatPrice(messages.vat)}} </span>
                  </div>
              </v-col>
              <v-col cols="12 flex-center-between font-20 pb-0" v-if="messages.pay_type.find(o => o === 3) && messages.credit_status == 1">
                  <div>เครดิตชาร์ต {{messages.credit_percent}}%</div>
                  <div>
                    <!-- <span class="color-gray line_through">180 </span> -->
                    <span>+ {{formatPrice(messages.credit_charge)}} </span>
                  </div>
              </v-col>
              <v-col cols="12 flex-center-between font-20 ">
                  <div>ชำระเงินด้วยแต้ม</div>
                  <div>
                    <!-- <span class="color-gray line_through">180 </span> -->
                    <span>- {{formatPrice(messages.payment_data.use_point)}} </span>
                  </div>
              </v-col>
              <v-col cols="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="12 flex-center-between font-20 ">
                
                  <div>ยอดเงินสุทธิ</div>
                  <div>
                    <!-- <span class="color-gray line_through">180 </span> -->
                    <span>{{formatPrice(messages.net)}} </span>
                  </div>
              </v-col>
            </v-row>


          </v-col>
          <v-col cols="6 pa-5 pr-5 ">
            <v-row>
              <v-col cols="12">
                <div class="text-right font-20 pt-5 pr-5 bg-cream color-fff">ยอดชำระ</div>
                <div class="text-center font-100 pr-5 bg-cream color-fff" >{{formatPrice(messages.net)}}</div>
              </v-col>
              <v-col cols="12 pt-5">
                <div class="font-22 bold">การชำระเงิน</div>
                <v-divider class="mt-3" style="border-color: #B0886B;"></v-divider>
              </v-col>
              <v-col cols="12">
                <p class="font-20">ข้อมูลสมาชิก</p>
                <p class="font-20" style="color: #B0886B" v-if="messages.payment_data.customer_name == null">เพื่อสะสมแต้มรับส่วนลด สมัครฟรี! ง่าย ด้วยเบอร์โทรศัพท์</p>
                <p class="font-20" v-else>{{messages.payment_data.customer_name}} คะแนนสะสม : {{formatPrice(messages.payment_data.customer_point)}}</p>
                <v-divider class="mt-3" style="border-color: #B0886B;"></v-divider>
              </v-col>
              <v-col cols="12 flex-center-between">
                <p class="font-20 mb-0">รับเงิน</p>
                <p v-if="messages.pay_type.find(o => o === 3) && messages.credit_status == 1" class="font-20 mb-0">{{formatPrice(messages.net)}}</p>
                <p v-else class="font-20 mb-0">{{formatPrice(messages.pay)}}</p>
              </v-col>
              <v-col cols="12 flex-center-between">
                <p class="font-20 ">เงินทอน</p>
                <p class="font-20" v-if="messages.change < 0 ">{{formatPrice(0)}}</p>
                <p class="font-20" v-else>{{formatPrice(messages.change)}}</p>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12 text-center">
                <p class="color-gray font-30 bold mb-0">THANK YOU</p>
                <p class="color-gray font-18">FOR YOUR ORDER</p>
                <div style="padding: 0 265px;">
                  <v-divider class="pb-3 text-center" style="border-color: #B0886B; "></v-divider>
                </div>
                <p class="color-gray font-18">{{messages.store_name}}</p>
              </v-col>
            </v-row>
           

            <!-- <div class="text-center pt-10">
              <img src="@/assets/arin_assets/logo_main.png" alt="logo" width="400" height="400">
            </div> -->
          </v-col>
        </v-row>
    </div>

  </div>
</template>

<script>
import io from 'socket.io-client';
import { formatPrice } from "@/js/handler";


export default {
  name: 'Chat',
  data() {
    return {
      // loading_page: true,
      messages: {
                product_data: [],
                payment_data: {use_point:0},
                promotion_discount: 0,
                discount_last: 0,
                total: 0,
                vat: 0,
                credit_charge: 0,
                credit_status: 0,
                credit_percent: 0,
                net: 0,
                pay: 0,
                pay_type: [],
                change: 0,
                store_name: null
      },
      newMessage: ''
    };
  },
  methods:{
    formatPrice(number){
      return formatPrice(number)
    }
  },
  mounted() {
    this.messages.store_name = this.$store.state.socket_list.store_name
    this.messages.credit_percent = this.$store.state.socket_list.credit_percent
    let socket_code = this.$store.state.socket_list.socket_code
    this.socket = io(process.env.VUE_APP_ARIN_BASE_URL.replace('/api', ''));
    this.socket.on(socket_code, (msg) => {
      this.messages = msg;
    });
  },
  beforeDestroy() {
    if (this.socket) {
      this.socket.disconnect();
    }
  }
};
</script>

<style scoped>
/* Add your CSS styles here */
.font-100{
  font-size: 90px;
}

.font-26{
  font-size: 26px;
}

.bg-cream{
  background-color: #B0886B;
}

.flex-center-between{
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.color-gray{
  color: #979797;
}

.color-org{
  color: #af935e;
}

.bg-org-bold{
  background-color: #B0886B !important;
  color: #fff;
}

.line_through {
  text-decoration: line-through;
}
.color-red{
  color: #F40018;
}
.color-fff{
  color: #fff;
}
.pa-5rem{
  padding: 5rem;
}

.scroll-monitor{
  overflow-y: auto;
  height: 370px;
}
</style>
